export default "__VITE_PUBLIC_ASSET__cee1c13b__"